import axios from 'axios'

export default{
    namespaced: true,
    state: {
        academicYearId: null,
    },
    getters: {
        getAcademicYearId (state) {
            return state.academicYearId
        },
    },
    mutations: {
        setAcademicYearId (state, value) {
            state.academicYearId = value
        },
    },
    actions: {

        getMarkSheetTerms () {
            let url = '/api/mark-sheet-terms';
            return axios.get(url);
        },
        
        getReportCardTerms () {
            let url = '/api/report-card-terms';
            return axios.get(url);
        },

        getClassListYears () {
            const url = '/api/class-list-years';
            return axios.get(url);
        }
    }
}    